// document.addEventListener("DOMContentLoaded", async () => {

//    // Detect Build Natively app using User-Agent
//   const ua = navigator.userAgent.toLowerCase();

//   if (ua.includes("natively")) {
    
//     // Debug (optional)
//     alert("Natively App Detected");

//   console.log("===== CART DEBUG START =====");
//   try {

//     // STEP 1 — Add test attribute
//     await fetch('/cart/update.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         attributes: {
//           checkout_context: "mobile_app"
//         }
//       })
//     });

//     console.log("Attribute update request sent");

//     // STEP 2 — Fetch full cart
//     const response = await fetch('/cart.js');
//     const cart = await response.json();

//     console.log("FULL CART DATA:", cart);

//     console.log("Cart Token:", cart.token);
//     console.log("Item Count:", cart.item_count);
//     console.log("Total Price:", cart.total_price);

//     console.log("Cart Attributes:", cart.attributes);

//     console.log("Cart Items:", cart.items);

//     cart.items.forEach((item, index) => {

//       console.log(`Item ${index + 1}`, {
//         title: item.title,
//         quantity: item.quantity,
//         price: item.price,
//         vendor: item.vendor,
//         product_id: item.product_id,
//         variant_id: item.variant_id,
//         properties: item.properties
//       });

//     });

//     console.log("===== CART DEBUG END =====");

//   } catch (err) {

//     console.error("Cart Debug Error:", err);

//   }

//   } else {
//     // Desktop/mobile browser → do nothing
//     console.log("Not a Natively App");
//   } 

// });

//alert


//document.addEventListener("DOMContentLoaded", () => {

  //const ua = navigator.userAgent.toLowerCase();

 // if (!ua.includes("natively")) {
 //   return;
 // }

  //alert("Natively App Detected");

  //async function setCartAttribute(step) {

  //  try {

    //  await fetch('/cart/update.js', {
      //  method: 'POST',
       // headers: {
      //    'Content-Type': 'application/json'
      //  },
      //  body: JSON.stringify({
      //    attributes: {
      //      checkout_context: "mobile_app"
     //     }
     //   })
     // });

    //  alert("Attribute set: mobile_app (" + step + ")");

   // } catch (error) {

    //  alert("Error setting attribute");

   // }

  //}

  // 1 App launch
  //setCartAttribute("App Launch");


  // 2 Add to cart
  //document.addEventListener("submit", function(e) {

   // const form = e.target;

   // if (form && form.action && form.action.includes("/cart/add")) {
   //   setCartAttribute("Add To Cart");
   // }

  //});


  // 3 Checkout click
  //document.addEventListener("click", async function(e) {

   // const el = e.target.closest("a,button");
   // if (!el) return;

   // const href = el.getAttribute("href") || "";

    //if (
   //   href.includes("/checkout") ||
     // el.name === "checkout" ||
    //  el.classList.contains("checkout") ||
    //  el.classList.contains("cart__checkout-button")
   // ) {

    //  e.preventDefault();

    //  await setCartAttribute("Before Checkout");

     // alert("Opening Checkout");

    //  window.location.href = "/checkout";

    //}

  //});

//});



class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    if (event.target.id.indexOf('pickup') > -1 || event.target.id.indexOf('extra_input_') > -1 || event.target.id.indexOf('storeUL') > -1 || event.target.id.indexOf('cr-delivery-zip') > -1) return;

    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        location.reload();
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}









 // DELETE ITEM
  document.querySelectorAll('.cart-delete-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = btn.dataset.line;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: 0 })
      });

      location.reload();
    });
  });

  // EDIT ITEM
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("cart-edit-modal");
  const modalContent = document.getElementById("edit-options-container");
  const updateBtn = document.getElementById("update-cart-btn");
  const closeBtn = document.querySelector(".custom-modal-close");

  const modalTitle = document.getElementById("modal-title");
  const modalPrice = document.getElementById("modal-price");
  const modalImage = document.getElementById("modal-image");

  let currentLine = null;

  document.querySelectorAll(".cart-edit-btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      const handle = this.dataset.productHandle;
      const variantId = this.dataset.variantId;
      currentLine = this.dataset.line;

      modal.classList.remove("hidden");

      fetch(`/products/${handle}.js`)
        .then((res) => res.json())
        .then((product) => {
          // Set title, image, price
          modalTitle.textContent = product.title;
          modalImage.src = product.images[0] || '';
          modalPrice.textContent = Shopify.formatMoney(product.price, "{{ shop.money_format }}");

          // Create dropdowns for options
          let optionsHTML = "";
          product.options.forEach((option, index) => {
            optionsHTML += `<label>${option}</label><select data-option-index="${index}">`;
            product.options_with_values[index].values.forEach((val) => {
              optionsHTML += `<option value="${val}">${val}</option>`;
            });
            optionsHTML += `</select>`;
          });

          modalContent.innerHTML = optionsHTML;

          // Save variants data
          modal.dataset.variants = JSON.stringify(product.variants);
        });
    });
  });

  // Close modal
 closeBtn.addEventListener("click", (e) => {
  e.preventDefault(); // Prevent form submission or button default behavior
  modal.classList.add("hidden");
});


// color size
  
document.querySelectorAll('.variant-color, .variant-size').forEach(select => {
  select.addEventListener('change', function () {
    const parent = this.closest('.cart-item-popup');
    const key = parent.dataset.key;
    const handle = parent.dataset.product;

    const selectedColor = parent.querySelector('.variant-color')?.value;
    const selectedSize = parent.querySelector('.variant-size')?.value;

    fetch(`/products/${handle}.js`)
      .then(response => {
        if (!response.ok) throw new Error("Failed to load product data");
        return response.json();
      })
      .then(product => {
        const variant = product.variants.find(v =>
          (!selectedColor || v.option1 === selectedColor) &&
          (!selectedSize || v.option2 === selectedSize)
        );

        if (!variant) {
          alert("This combination is not available.");
          return;
        }

        // Remove old variant
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(() => {
          // Add new variant
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variant.id, quantity: 1 })
          });
        })
      })
      .catch(error => {
        console.error("Error fetching product data:", error);
      });
  });
});



 
  // Update cart
  updateBtn.addEventListener("click", function () {
    const selects = modal.querySelectorAll("select");
    const selectedOptions = Array.from(selects).map((s) => s.value);

    const variants = JSON.parse(modal.dataset.variants);
    const matchedVariant = variants.find((variant) =>
      variant.options.every((opt, i) => opt === selectedOptions[i])
    );

    if (matchedVariant) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          line: parseInt(currentLine),
          id: matchedVariant.id,
          quantity: 1,
        }),
      })
        .then((res) => res.json())
        .then(() => location.reload());
    } else {
      alert("This variant is not available.");
    }
  });
});

















